import { render, staticRenderFns } from "./CopyStakeJackpotCampaignsTable.vue?vue&type=template&id=7fa3516a&scoped=true&lang=pug"
import script from "./CopyStakeJackpotCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeJackpotCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeJackpotCampaignsTable.vue?vue&type=style&index=0&id=7fa3516a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3516a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMenu,VProgressLinear,VSelect,VSpacer,VTextField})
